// src/store/models/notice.js
import {
  getUnreadNotices,
  markNoticeRead,
  markAllNoticesRead,
} from '@common/api';

const initialState = {
  unreadList: [], // 未读通知列表
  hasUnread: false, // 是否有未读（用于 Header 红点）
  latestNotice: null, // 最新一条通知（用于全局弹窗）
};

export const notice = {
  state: initialState,
  reducers: {
    // 设置未读列表
    setUnreadList: (state, payload) => {
      state.unreadList = payload || [];
      state.hasUnread = state.unreadList.length > 0;
      state.latestNotice = state.unreadList[0] || null;
      return state;
    },
    // 标记单条已读
    markAsRead: (state, id) => {
      state.unreadList = state.unreadList.filter((item) => item.id !== id);
      state.hasUnread = state.unreadList.length > 0;
      state.latestNotice = state.unreadList[0] || null;
      return state;
    },
    // 标记全部已读
    markAllAsRead: (state) => {
      state.unreadList = [];
      state.hasUnread = false;
      state.latestNotice = null;
      return state;
    },
  },
  effects: (dispatch) => ({
    // 获取未读通知列表
    async fetchUnreadNotices() {
      try {
        const { data, error_code, error_msg } = await getUnreadNotices();
        if (error_code) {
          return Promise.reject(error_msg);
        }
        // data.list 是通知数组
        dispatch.notice.setUnreadList(data.list || []);
        return { error_code: 0, error_msg: 'SUCCESS', data };
      } catch (error) {
        console.error('获取通知失败:', error);
        return { error_code: -1, error_msg: '获取通知失败' };
      }
    },
    // 标记单条已读
    async markNoticeRead(id) {
      try {
        const { data, error_code, error_msg } = await markNoticeRead(id);
        if (error_code) {
          return Promise.reject(error_msg);
        }
        dispatch.notice.markAsRead(id);
        return { error_code: 0, error_msg: 'SUCCESS', data };
      } catch (error) {
        console.error('标记已读失败:', error);
        return { error_code: -1, error_msg: '标记已读失败' };
      }
    },
    // 标记全部已读
    async markAllNoticesRead() {
      try {
        const { data, error_code, error_msg } = await markAllNoticesRead();
        if (error_code) {
          return Promise.reject(error_msg);
        }
        dispatch.notice.markAllAsRead();
        return { error_code: 0, error_msg: 'SUCCESS', data };
      } catch (error) {
        console.error('全部已读失败:', error);
        return { error_code: -1, error_msg: '全部已读失败' };
      }
    },
  }),
};
